import { useLocation, useNavigate } from 'react-router-dom'
import { hasValue } from '../../helpers'
import { useSelector } from 'react-redux'
import { Form } from 'react-bootstrap'
import './SearchFilters.scss'

export default function SearchFilters({ city }) {
  const location = useLocation()
  const navigate = useNavigate()

  const cities = useSelector(state => state.utility?.cities ?? [])

  const queryParams = new URLSearchParams(location.search)

  const onCityChange = e => {
    const selectedCity = e.target.value

    if (hasValue(selectedCity)) {
      queryParams.set('grad', selectedCity)
      queryParams.set('page', 1)
    } else {
      // clear city filter
      queryParams.delete('grad')
    }

    navigate(`?${queryParams.toString()}`)
    window.scrollTo({ top: 70, behavior: 'smooth' })
  }
  return (
    <div className="group-wrapper filters-section">
      <h5 className="mb-0">{`Filteri`}</h5>

      <hr className="hr divider" />

      <Form.Group>
        <Form.Label className="fw-bold">Grad</Form.Label>
        <Form.Select
          title="Grad"
          name="city"
          value={city}
          onChange={onCityChange}>
          <option key="default" value="">
            Izaberite grad
          </option>

          {cities.map(option => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      <hr className="hr divider" />
    </div>
  )
}
